import request from "./request";

export default async ({ salesorderId }) => {
    const resp = await request.get("salesorderById", { params: { salesorderId } });

    return resp;
}